import { render, staticRenderFns } from "./TerritorialCommunities.vue?vue&type=template&id=00594695&"
import script from "./TerritorialCommunities.vue?vue&type=script&lang=js&"
export * from "./TerritorialCommunities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports